<article
  class="sm-container-list-item"
  [class.sm-container-list-item--selected]="isSelected"
  [class.sm-container-list-item--disabled]="isDisabled">
  <div class="sm-container-list-item__metadata"><ng-content select="[inventoryMetadata]"></ng-content></div>
  @if (interactive) {
    <button
      class="sm-container-list-item__main"
      [class.sm-container-list-item__main--drag-source]="dragEnabled"
      type="button"
      [attr.aria-current]="isSelected ? 'page' : null"
      [disabled]="isDisabled"
      (click)="handleMainClick($event)"
      (contextmenu)="handleContextMenu($event)"
      (dragstart)="preventNativeDrag($event)"
      (pointerdown)="handleDragPointerDown($event)"
      (pointermove)="handleDragPointerMove($event)"
      (pointerup)="handleDragPointerEnd($event)"
      (pointercancel)="handleDragPointerCancel($event)">
      <ng-container [ngTemplateOutlet]="containerMainContent"></ng-container>
    </button>
  } @else {
    <div class="sm-container-list-item__main sm-container-list-item__main--static">
      <ng-container [ngTemplateOutlet]="containerMainContent"></ng-container>
    </div>
  }
  <ng-template #containerMainContent>
    <span
      class="sm-container-list-item__media"
      [class.sm-container-list-item__media--touch-drag-source]="dragEnabled"
      aria-hidden="true">
      @if (hasImage) {
        <sm-image-preview sourceKind="container" [sourceId]="container.id" [src]="container.imageUrl || ''" [alt]="container.name"></sm-image-preview>
      } @else {
        <ion-icon class="sm-container-list-item__icon" name="file-tray-outline"></ion-icon>
      }
    </span>

    <span class="sm-container-list-item__copy">
      <span class="sm-container-list-item__title-row"><span class="sm-container-list-item__name"><sm-search-highlight [text]="container.name" [query]="searchQuery"></sm-search-highlight></span>
      @if (container.isFavorite) { <ion-icon class="favorite-star" name="star" role="img" [attr.aria-label]="'favorites.selected' | translate"></ion-icon> }
        <ion-icon class="sm-container-list-item__kind" name="file-tray-outline" role="img"
          [attr.aria-label]="'homePage.containerKindLabel' | translate"
          [attr.title]="'homePage.containerKindLabel' | translate"></ion-icon></span>

      @if (description || emptyDescriptionLabel) {
        <sm-rich-tooltip
          class="sm-container-list-item__description"
          [previewText]="description"
          [searchQuery]="descriptionHtml ? searchQuery : ''"
          [html]="descriptionHtml"
          [emptyLabel]="emptyDescriptionLabel">
        </sm-rich-tooltip>
      }

      @if (hasKnownContentState) {
        <span class="sm-container-list-item__content-state">
          @if (!container.hasItems && !container.hasChildren) {
            <span class="sm-container-list-item__content-state-item sm-container-list-item__content-state-item--empty">
              <ion-icon name="ellipse-outline" aria-hidden="true"></ion-icon>
              <span>{{ emptyStateLabel }}</span>
            </span>
          }

          @if (container.hasItems) {
            <span class="sm-container-list-item__content-state-item">
              <ion-icon name="cube-outline" aria-hidden="true"></ion-icon>
              <span>{{ hasItemsStateLabel }}</span>
            </span>
          }

          @if (container.hasChildren) {
            <span class="sm-container-list-item__content-state-item">
              <ion-icon name="file-tray-outline" aria-hidden="true"></ion-icon>
              <span>{{ hasChildrenStateLabel }}</span>
            </span>
          }
        </span>
      }

      @if (container.contextPathText || container.contextText) {
        <div class="sm-container-list-item__context">
          <ion-icon
            class="sm-container-list-item__context-icon"
            [name]="container.contextIconName || 'location-outline'">
          </ion-icon>
          <div class="sm-container-list-item__context-copy">
            @if (container.contextPathText) {
              <span class="sm-container-list-item__context-path" [attr.aria-label]="container.contextAriaLabel || container.contextPathText">
                {{ container.contextPathText }}
              </span>
            } @else {
              <span class="sm-container-list-item__context-text" [attr.aria-label]="container.contextAriaLabel || container.contextText">
                {{ container.contextText }}
              </span>
            }

            @if (container.contextMetaText) {
              <span class="sm-container-list-item__context-meta">{{ container.contextMetaText }}</span>
            }
          </div>
        </div>
      }
    </span>
  </ng-template>

  @if (inventoryMenu) {
    <sm-container-context-menu class="sm-container-list-item__menu" [entity]="container"
      [options]="inventoryMenu" [triggerAriaLabel]="menuAriaLabel || container.name" triggerVariant="ellipsis"
      (itemSelect)="handleMenuItemSelect($event)">
      <span class="sm-container-list-item__menu-trigger">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </span>
    </sm-container-context-menu>
  } @else if (menuItems.length) {
    <sm-context-menu
      class="sm-container-list-item__menu"
      [items]="menuItems"
      [triggerAriaLabel]="menuAriaLabel || container.name"
      triggerVariant="ellipsis"
      menuWidth="content"
      (itemSelect)="handleMenuItemSelect($event)">
      <span smContextMenuTrigger class="sm-container-list-item__menu-trigger">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </span>
    </sm-context-menu>
  }
</article>
